// src/layouts/AccountLayout.jsx
 import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import AccountSideNav from '../components/AccountSideNav/AccountSideNav'; // Will be created soon
import styles from './AccountLayout.module.css'; // Will be created soon

const AccountLayout = () => {
    return (
        <div className={styles.accountLayoutContainer}> {/* Similar to adminLayoutContainer */}
            <Navbar />
            <div className={styles.accountPageWrapper}> {/* Similar to adminPageWrapper */}
                <AccountSideNav /> {/* Placeholder for now */}
                <main className={styles.accountMainContent}> {/* Similar to adminMainContent */}
                    <Outlet /> {/* Child routes will render here */}
                </main>
            </div>
            <Footer />
        </div>
    );
};

export default AccountLayout;